module.exports = __webpack_public_path__ + "assets/img/teacher_top5.8ecf5d34.png";